// ProductsSheets.jsx — feuilles montantes (bottom-sheets) du module Produits.
// Montées DANS le conteneur .eap (pas de portal) pour rester scopées.
import React, { useEffect, useState } from "react";
import { Ico, useIcons, fmt } from "./productsShared";

/* Coquille générique : gère le montage + la transition d'ouverture/fermeture. */
export function Sheet({ open, onClose, children }) {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (open) {
      setMounted(true);
      const r = requestAnimationFrame(() => setShown(true));
      return () => cancelAnimationFrame(r);
    }
    setShown(false);
    const t = setTimeout(() => setMounted(false), 340);
    return () => clearTimeout(t);
  }, [open]);
  if (!mounted) return null;
  return (
    <div className={"sheet-host" + (shown ? " open" : "")}>
      <div className="sheet-scrim" onClick={onClose} />
      <div className="sheet">{children}</div>
    </div>
  );
}

/* Sélecteur d'option (catégorie, unité, entrepôt, taxe…). */
export function OptionSheet({ open, title, items, selected, onPick, onClose, addLabel }) {
  useIcons();
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="sheet__grip" />
      <div className="sheet__h">
        <h3>{title}</h3>
        <button className="sheet__close" onClick={onClose}><Ico name="x" /></button>
      </div>
      <div className="sheet__b">
        {items.map((it) => (
          <button
            key={it.name}
            className={"opt" + (it.name === selected ? " sel" : "")}
            onClick={() => onPick(it.name)}
          >
            {it.ico ? <span className="oico"><Ico name={it.ico} /></span> : null}
            <span>
              <div>{it.name}</div>
              {it.sub ? <div className="osub">{it.sub}</div> : null}
            </span>
            <Ico name="check" className="check" />
          </button>
        ))}
        {addLabel ? (
          <button className="opt-add" onClick={() => onPick("__add__")}>
            <Ico name="plus-circle" />{addLabel}
          </button>
        ) : null}
      </div>
    </Sheet>
  );
}

/* Menu « … » de la fiche détail. */
export function MoreSheet({
  open,
  onClose,
  onAction,
  canEdit = true,
  canDelete = true,
  canManageStatus = true,
}) {
  const items = [
    { name: "Modifier la fiche", ico: "pencil", act: "edit" },
    { name: "Imprimer le code-barres", ico: "printer", act: "printbc" },
    { name: "Gérer le statut", ico: "ban", act: "disable" },
    { name: "Supprimer", ico: "trash-2", act: "delete" },
  ].filter((item) => {
    if (item.act === "edit") return canEdit;
    if (item.act === "delete") return canDelete;
    if (item.act === "disable") return canManageStatus;
    return true;
  });
  useIcons();
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="sheet__grip" />
      <div className="sheet__h">
        <h3>Options</h3>
        <button className="sheet__close" onClick={onClose}><Ico name="x" /></button>
      </div>
      <div className="sheet__b">
        {items.map((it) => (
          <button key={it.act} className="opt" onClick={() => onAction(it.act)}>
            <span className="oico"><Ico name={it.ico} /></span>
            <span><div>{it.name}</div></span>
          </button>
        ))}
      </div>
    </Sheet>
  );
}

/* Confirmation de suppression. */
export function ConfirmDeleteSheet({ open, product, onClose, onConfirm }) {
  useIcons();
  return (
    <Sheet open={open} onClose={onClose}>
      <div className="sheet__grip" />
      <div className="sheet__b pad" style={{ textAlign: "center" }}>
        <div className="confirm-ic"><Ico name="trash-2" /></div>
        <h3 style={{ margin: "14px 0 6px", fontSize: 18, fontWeight: 800 }}>
          Supprimer ce produit ?
        </h3>
        <p style={{ margin: "0 0 20px", fontSize: 14, color: "var(--muted)", lineHeight: 1.5 }}>
          «&nbsp;<b style={{ color: "var(--ink)" }}>{product ? product.name : ""}</b>&nbsp;» sera
          retiré du catalogue. Cette action est définitive.
        </p>
        <button className="btn btn--danger btn--block" style={{ marginBottom: 10 }} onClick={onConfirm}>
          <Ico name="trash-2" />Supprimer définitivement
        </button>
        <button className="btn btn--ghost btn--block" onClick={onClose}>Annuler</button>
      </div>
    </Sheet>
  );
}
